import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useStyles } from "../../../theme/appStyles";
import { useNavigate } from "react-router";
import {
  useGetAllByPolicyNumberQuery,
  useGetCustomerRelationQuery,
  useGetCustomerQuery,
  useGetProductBrandQuery,
  useGetProductQuery,
  useGetSettingQuery,
} from "../../../Api/attoDeskApi";
import {
  ICustomerRelative2,
  ICustomer,
  IPolicy,
  IProductBrand,
  IProductPopUP,
  policyAllPrintTermsArray,
  policyTermsArray,
  ICustomerRelative,
  ICompanyDetails,
} from "../../../Api/Interface/api.interface";
import dayjs, { Dayjs } from "dayjs";
import { useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import LogoMain from "../../../Images/logo.png";
import { formatPhoneNumberForDisplay } from "../../../Components/Validation/validationUtils";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { styled } from "@mui/material/styles";
import { GlobalStyles } from "@mui/material";
import { formatNumber } from "../../../Components/formatNumber/formatNumber";
import { Link } from "react-router-dom";

const capitalizeFirstLetter = (name: string | null | undefined) => {
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

const toAllCaps = (text: string | null | undefined): string => {
  if (!text) return "";
  return text.toUpperCase();
};

// const PrintContainer = styled("div")({
//   "@media print": {
//     pageBreakInside: "avoid",

//     // table: {
//     //   borderCollapse: "collapse",
//     //   width: "100%",
//     // },
//     // "th, td": {
//     //   border: "1px solid #767c83 !important",
//     //   padding: "12px !important",
//     //   color: "#000 !important",
//     // },
//     // "thead th": {
//     //   backgroundColor: "#dadee5 !important",
//     // },
//     // "table *": {
//     //   WebkitPrintColorAdjust: "exact",
//     //   printColorAdjust: "exact",
//     // },
//   },
//   "@page": {
//     marginTop: "10px",
//     marginBottom: "10px",
//     // paddingTop: "300px",
//     // paddingBottom: "300px",
//   },
// });

// const PrintContainer = styled("div")({
//   "@page": {
//     paddingTop: "30px",
//     paddingBottom: "30px",
//   },
// });

const PrintContainer = styled("div")({
  "@media print": {
    "@page": {
      //   paddingTop: "30px",
      //   paddingBottom: "30px",
      // "@bottom-right": {
      //   content: '"Page " counter(page)',
      //   color: "#333",
      //   fontSize: "12px"
      // }
    },
  },
});

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const { customerId, policyNumber } = useParams<{
    customerId: string;
    policyNumber: string;
  }>();

  const componentRef = useRef<HTMLDivElement>(null);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [initialData, setInitialData] = useState<ICompanyDetails | null>(null);

  const { data, isLoading, isError } = useGetCustomerQuery({
    searchText: "",
    id: String(customerId),
  });

  const {
    data: settingData,
    isLoading: settingIsLoading,
    isError: settingIsError,
  } = useGetSettingQuery({
    searchText: "",
    id: "1",
  });

  const {
    data: customerProjectData,
    isLoading: customerProjectDataIsLoading,
    refetch: cutomerProjectRefetch,
    isError: cutomerProjectisError,
  } = useGetAllByPolicyNumberQuery({
    searchText: "",
    id: "",
    policyCustomerId: String(customerId),
    policyNumber: String(policyNumber),
  });

  const { data: brandListData, isLoading: brandIsLoading } =
    useGetProductBrandQuery({
      searchText: "",
      isActive: true,
    });

  const { data: customerFullData, isLoading: customerFullDataISLoading } =
    useGetCustomerQuery({
      searchText: "",
      id: "",
    });

  const {
    data: productData,
    isLoading: productDataIsLoading,
    isError: productDataError,
  } = useGetProductQuery({
    searchText: "",
    id: "",
    productBrandId: null,
    productCategoryId: null,
    productTagIds: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
  });

  const policyCustomerId = String(customerId || "");

  const {
    data: relativeData,
    isLoading: relativeIsLoading,
    isError: relativeError,
  } = useGetCustomerRelationQuery(
    { policyCustomerId },
    { skip: !policyCustomerId }
  );

  useEffect(() => {
    if (settingData?.data) {
      setInitialData(settingData.data as ICompanyDetails);
    }
  }, [settingData]);

  const customer = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as ICustomer;
    }
    return null;
  }, [data]);

  const project: IPolicy[] = useMemo(() => {
    if (customerProjectData && Array.isArray(customerProjectData.data)) {
      return customerProjectData.data as IPolicy[];
    }
    return [];
  }, [customerProjectData]);

  const relationDataList = useMemo(() => {
    return (relativeData?.data ?? []) as ICustomerRelative2[];
  }, [relativeData?.data]);

  const relativeList = useMemo(() => {
    return relativeData?.data as ICustomerRelative[];
  }, [relativeData?.data]);

  const brandList = useMemo(() => {
    return brandListData?.data as IProductBrand[];
  }, [brandListData?.data]);

  const customerAllList = useMemo(() => {
    return customerFullData?.data as ICustomer[];
  }, [customerFullData?.data]);

  const productList = useMemo(() => {
    return productData?.data as IProductPopUP[];
  }, [productData?.data]);

  const brandMap = useMemo(() => {
    const map = new Map();
    brandList?.forEach((category) => {
      map.set(category.id, category.productBrandName);
    });
    return map;
  }, [brandList]);

  const relativeMap = useMemo(() => {
    const map = new Map();
    relationDataList?.forEach((item) => {
      map.set(item.id, `${toProperCase(item?.related_customer_name)}`);
    });
    return map;
  }, [relationDataList]);

  const productMap = useMemo(() => {
    const map = new Map();
    productList?.forEach((brand) => {
      map.set(brand.id, brand.productName);
    });
    return map;
  }, [productList]);

  const customerMap = useMemo(() => {
    const map = new Map();
    customerAllList?.forEach((category) => {
      map.set(
        category.id,
        capitalizeFirstLetter(category.customerFirstName) +
          " " +
          capitalizeFirstLetter(category.customerLastName)
      );
    });
    return map;
  }, [customerAllList]);

  const firstPolicy = project[0] || {};

  const fontwhighte = 550;
  const documentName = `${customer?.customerFirstName || ""} ${
    customer?.customerLastName || ""
  }_${new Date().toLocaleDateString()}`;

  const today = dayjs();
  const formattedDate = dayjs(today).format("MMM D, YYYY");

  const formatAddress = (
    customerAddresLine: string,
    customerCity: string,
    customerProvince: string,
    customerPostalCode: string
  ) => {
    return `${capitalizeFirstLetter(
      customerAddresLine
    )} ${capitalizeFirstLetter(customerCity)},\n${capitalizeFirstLetter(
      customerProvince
    )} ${capitalizeFirstLetter(customerPostalCode)}`;
  };

  const allPolicyItems = project.flatMap((policy) => [
    ...(policy.policyTermsArray?.filter((item) => item.isReport) || []),
    ...(policy.policySummaryReportArray?.filter(
      (item) => item.isPolicyTermsSummaryReport
    ) || []),
  ]);

  if (
    isLoading ||
    productDataIsLoading ||
    customerProjectDataIsLoading ||
    brandIsLoading ||
    customerFullDataISLoading ||
    relativeIsLoading
  )
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.quotesCardInvoice}>
            <Grid container spacing={1} px={2} py={2}>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                  <Grid item>
                    <Link
                      to={`/coverage-report/customer/${customerId}/policy/secound/${String(
                        policyNumber
                      )}`}
                      className={classes.iconLinkPropNormal}
                    >
                      <Button
                        // variant="outlined"
                        className={classes.addNewButton}
                        onClick={() =>
                          navigate(
                            `/coverage-report/customer/${customerId}/policy/secound/${String(
                              policyNumber
                            )}`
                          )
                        }
                      >
                        Type 2 pdf
                      </Button>
                    </Link>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      startIcon={<ArrowBackIcon />}
                      className={classes.addButton}
                      onClick={() => navigate(-1)}
                    >
                      Back
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <PrintContainer ref={componentRef}>
            <Card className={classes.quotesCardInvoice}>
              <Grid container spacing={1} padding={"2px"}>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className={classes.titleGrid}
                >
                  <Grid
                    container
                    className={classes.titleGridInvoice}
                    justifyContent={"space-between"}
                    padding={1}
                  >
                    <Grid item lg={12} md={12} sm={12} xs={12} pb={2}>
                      <Grid container spacing={"4px"}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Grid
                            container
                            spacing={1}
                            justifyContent="space-between"
                            alignItems="flex-start"
                          >
                            {/* Left Side: Logo */}
                            <Grid item>
                              <img
                                src={LogoMain}
                                alt="AttoDesk Logo"
                                style={{
                                  width: "300px",
                                  height: "auto",
                                  display: "block",
                                }}
                              />
                            </Grid>

                            {/* Right Side: Contact Info stacked vertically */}
                            <Grid item>
                              <Grid
                                container
                                direction="column"
                                spacing={"1px"}
                              >
                                {customer &&
                                  (customer.customerFirstName ||
                                    customer.customerLastName) && (
                                    <Grid item textAlign={"right"}>
                                      <Typography
                                        className={classes.bodyPrint1}
                                      >
                                        {/* <span style={{ fontWeight: fontwhighte }}>
                                        Name:&nbsp;
                                      </span> */}
                                        {(customer?.customerFirstName || "") +
                                          " " +
                                          (customer?.customerLastName || "")}
                                      </Typography>
                                    </Grid>
                                  )}
                                {customer && customer.customerHomeMobileNum && (
                                  <Grid item textAlign={"right"}>
                                    <Typography className={classes.bodyPrint1}>
                                      <span style={{ fontWeight: fontwhighte }}>
                                        Home Phone:&nbsp;
                                      </span>
                                      {formatPhoneNumberForDisplay(
                                        customer.customerHomeMobileNum
                                      )}
                                    </Typography>
                                  </Grid>
                                )}

                                {customer && customer.customerMobileNum && (
                                  <Grid item textAlign={"right"}>
                                    <Typography className={classes.bodyPrint1}>
                                      <span style={{ fontWeight: fontwhighte }}>
                                        Cell Phone:&nbsp;
                                      </span>
                                      {formatPhoneNumberForDisplay(
                                        customer.customerMobileNum
                                      )}
                                    </Typography>
                                  </Grid>
                                )}

                                {customer && customer.customerWorkMobileNum && (
                                  <Grid item textAlign={"right"}>
                                    <Typography className={classes.bodyPrint1}>
                                      <span style={{ fontWeight: fontwhighte }}>
                                        Work Phone:&nbsp;
                                      </span>
                                      {formatPhoneNumberForDisplay(
                                        customer.customerWorkMobileNum
                                      )}
                                    </Typography>
                                  </Grid>
                                )}

                                {customer && customer.customerEmail && (
                                  <Grid item textAlign={"right"}>
                                    <Typography className={classes.bodyPrint1}>
                                      <span style={{ fontWeight: fontwhighte }}>
                                        Email:&nbsp;
                                      </span>
                                      {customer.customerEmail.toLowerCase()}
                                    </Typography>
                                  </Grid>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          // className={classes.policySummaryBox}
                          className={classes.titleGrid}
                          textAlign={"center"}
                          justifyContent={"center"}
                          // sx={{ borderBottom: 1, mt: 2 }}
                          sx={{ mt: 2 }}
                        >
                          {/* <Typography className={classes.policySummaryTitile}>
                            Policy Summary
                          </Typography> */}
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography className={classes.bodyPrint1}>
                            {/* <span style={{ fontWeight: fontwhighte }}> */}
                            Date :&nbsp;&nbsp;
                            {/* </span>{" "} */}
                            {formattedDate}
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          {customer &&
                            (customer.customerFirstName ||
                              customer.customerLastName) && (
                              <Typography className={classes.bodyPrint1}>
                                {(customer?.customerFirstName || "") +
                                  " " +
                                  (customer?.customerLastName || "")}
                              </Typography>
                            )}
                          {/* {customer &&
                            (customer.customerAddresLine ||
                              customer.customerCity) && (
                              <Typography
                                className={classes.bodyPrint1}
                                // sx={{
                                //   textTransform: "uppercase",
                                //   color: "black",
                                // }}
                              >
                                {toProperCase(
                                  customer?.customerAddresLine || ""
                                ) +
                                  " " +
                                  toProperCase(customer?.customerCity || "")}
                              </Typography>
                            )}
                          {customer &&
                            (customer.customerProvince ||
                              customer.customerPostalCode) && (
                              <Typography
                                className={classes.bodyPrint1}
                                // sx={{
                                //   textTransform: "uppercase",
                                //   // color: "black",
                                // }}
                              >
                                {toAllCaps(customer?.customerProvince || "") +
                                  " " +
                                  toAllCaps(customer?.customerPostalCode || "")}
                              </Typography>
                            )} */}

                          {customer && (
                            <Typography className={classes.bodyPrint1}>
                              {[
                                customer.customerAddresLine &&
                                  toProperCase(customer.customerAddresLine),
                                customer.customerCity &&
                                  toProperCase(customer.customerCity),
                                customer.customerProvince &&
                                  toAllCaps(customer.customerProvince),
                                customer.customerPostalCode &&
                                  toAllCaps(customer.customerPostalCode),
                              ]
                                .filter(Boolean)
                                .join(", ")}
                            </Typography>
                          )}
                        </Grid>

                        {customer && customer.customerFirstName && (
                          <Grid item lg={12} md={12} sm={12} xs={12} mt={1}>
                            <Typography
                              className={classes.bodyPrint1}
                              sx={{
                                lineHeight: 0.2,
                              }}
                            >
                              Dear {customer?.customerFirstName || ""},
                            </Typography>
                          </Grid>
                        )}

                        {initialData && initialData.header_message && (
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography
                              className={classes.bodyPrint133}
                              component="div"
                              sx={{
                                lineHeight: 0.2,
                              }}
                              dangerouslySetInnerHTML={{
                                __html: initialData.header_message,
                              }}
                            />
                          </Grid>
                        )}

                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          pt={2}
                          mx={1}
                          className={classes.titleGrid}
                        >
                          <Grid container spacing={1}>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <TableContainer>
                                <Table className={classes.tableReport}>
                                  <TableHead
                                    className={classes.tableHeaderRowReport}
                                  >
                                    <TableRow>
                                      <TableCell
                                        className={classes.tablheaderReport}
                                        colSpan={3}
                                        sx={{
                                          width: "100%",
                                          padding: "none",
                                        }}
                                      >
                                        <Grid container spacing={"1px"}>
                                          <Grid
                                            item
                                            lg={6}
                                            md={6}
                                            sm={6}
                                            xs={6}
                                          >
                                            {firstPolicy.policyNumber && (
                                              <Typography
                                                className={classes.bodyPrint1}
                                              >
                                                <span
                                                  style={{
                                                    fontWeight: fontwhighte,
                                                  }}
                                                >
                                                  Policy Number :&nbsp;&nbsp;
                                                </span>{" "}
                                                {firstPolicy.policyNumber ||
                                                  " "}
                                              </Typography>
                                            )}
                                            {firstPolicy.policyInsuranceCompanyId && (
                                              <Typography
                                                className={classes.bodyPrint1}
                                              >
                                                <span
                                                  style={{
                                                    fontWeight: fontwhighte,
                                                  }}
                                                >
                                                  Company Name :&nbsp;&nbsp;
                                                </span>{" "}
                                                {brandMap.get(
                                                  Number(
                                                    firstPolicy.policyInsuranceCompanyId
                                                  )
                                                ) || ""}
                                              </Typography>
                                            )}
                                            {firstPolicy.policyIssueDate && (
                                              <Typography
                                                className={classes.bodyPrint1}
                                              >
                                                <span
                                                  style={{
                                                    fontWeight: fontwhighte,
                                                  }}
                                                >
                                                  Issue Date :&nbsp;&nbsp;
                                                </span>{" "}
                                                {firstPolicy.policyIssueDate
                                                  ? dayjs(
                                                      firstPolicy.policyIssueDate
                                                    ).format("MMM D, YYYY")
                                                  : ""}
                                              </Typography>
                                            )}
                                          </Grid>
                                          <Grid
                                            item
                                            lg={6}
                                            md={6}
                                            sm={6}
                                            xs={6}
                                          >
                                            {firstPolicy.policyPayor && (
                                              <Typography
                                                className={classes.bodyPrint1}
                                              >
                                                <span
                                                  style={{
                                                    fontWeight: fontwhighte,
                                                  }}
                                                >
                                                  Payor Name :&nbsp;&nbsp;
                                                </span>{" "}
                                                {firstPolicy.policyPayor || " "}
                                              </Typography>
                                            )}
                                            {firstPolicy.policyDrawDay && (
                                              <Typography
                                                className={classes.bodyPrint1}
                                              >
                                                <span
                                                  style={{
                                                    fontWeight: fontwhighte,
                                                  }}
                                                >
                                                  Draw Day :&nbsp;&nbsp;
                                                </span>{" "}
                                                {firstPolicy.policyDrawDay ||
                                                  " "}
                                              </Typography>
                                            )}
                                          </Grid>
                                        </Grid>
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell
                                        className={classes.tablheaderReport}
                                        sx={{
                                          // textAlign: "center",
                                          width: "50%",
                                        }}
                                      >
                                        <Typography
                                          className={classes.bodyPrint1333}
                                        >
                                          <strong>Details</strong>
                                        </Typography>
                                      </TableCell>
                                      <TableCell
                                        className={classes.tablheaderReport}
                                        sx={{
                                          textAlign: "right",
                                          width: "30%",
                                        }}
                                      >
                                        <Typography
                                          className={classes.bodyPrint1333}
                                        >
                                          <strong>Coverage Amount </strong>
                                        </Typography>
                                      </TableCell>
                                      <TableCell
                                        className={classes.tablheaderReport}
                                        sx={{
                                          textAlign: "right",
                                          width: "20%",
                                        }}
                                      >
                                        <Typography
                                          className={classes.bodyPrint1333}
                                        >
                                          <strong>Premium</strong>
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {cutomerProjectisError ||
                                    project.length === 0 ? (
                                      <TableRow>
                                        <TableCell colSpan={8} align="center">
                                          {cutomerProjectisError
                                            ? "Error fetching data"
                                            : "No data available"}
                                        </TableCell>
                                      </TableRow>
                                    ) : (
                                      project.map((policy, index) => (
                                        <TableRow
                                          className={classes.tableRowReport}
                                          key={policy.id}
                                        >
                                          <TableCell
                                            className={classes.tablCellReport}
                                            sx={{
                                              width: "50%",
                                            }}
                                          >
                                            {policy.policyProductId && (
                                              <Typography
                                                className={
                                                  classes.bodyPrintHeading
                                                }
                                                sx={{
                                                  textTransform: "uppercase",
                                                  color: "black",
                                                  fontWeight: "400 !important",
                                                }}
                                              >
                                                {productMap.get(
                                                  Number(policy.policyProductId)
                                                ) || ""}
                                              </Typography>
                                            )}
                                            {policy.policyInsuredDetails &&
                                              policy.policyInsuredDetails
                                                .length > 0 && (
                                                <Typography
                                                  className={classes.bodyPrint1}
                                                >
                                                  <span
                                                    style={{
                                                      fontWeight: fontwhighte,
                                                    }}
                                                  >
                                                    Insured :&nbsp;&nbsp;
                                                  </span>{" "}
                                                  <strong> </strong>{" "}
                                                  {policy.policyInsuredDetails.map(
                                                    (insuredId, index) => {
                                                      const customerName =
                                                        relativeMap.get(
                                                          Number(insuredId)
                                                        ) || "";

                                                      return (
                                                        <span key={insuredId}>
                                                          {customerName}
                                                          {index <
                                                            policy
                                                              .policyInsuredDetails
                                                              .length -
                                                              1 && ", "}
                                                        </span>
                                                      );
                                                    }
                                                  )}
                                                </Typography>
                                              )}
                                            {(policy.policyIsLifeTimeExpiryDate ||
                                              policy.policyExpiryDate) && (
                                              <Typography
                                                className={classes.bodyPrint1}
                                              >
                                                {/* Expires :&nbsp;&nbsp; */}
                                                <span
                                                  style={{
                                                    fontWeight: fontwhighte,
                                                  }}
                                                >
                                                  Expires :&nbsp;&nbsp;
                                                </span>{" "}
                                                {policy.policyIsLifeTimeExpiryDate
                                                  ? "Death"
                                                  : policy.policyExpiryDate
                                                  ? dayjs(
                                                      policy.policyExpiryDate
                                                    ).format("MMM D, YYYY")
                                                  : ""}
                                              </Typography>
                                            )}

                                            {policy.policyPrimaryBenificariesNew &&
                                              policy
                                                .policyPrimaryBenificariesNew
                                                .length > 0 && (
                                                <Typography
                                                  className={classes.bodyPrint1}
                                                >
                                                  {/* Beneficiaries :&nbsp;&nbsp; */}
                                                  <span
                                                    style={{
                                                      fontWeight: fontwhighte,
                                                    }}
                                                  >
                                                    Beneficiaries :&nbsp;&nbsp;
                                                  </span>{" "}
                                                  {/* {policy.policyPrimaryBenificariesNew.map(
                                                  (insured, index) => (
                                                    <span key={index}>
                                                      {toProperCase(
                                                        insured.name
                                                      )}{" "}
                                                      {insured.payoutPercentage
                                                        ? `- ${insured.payoutPercentage}%`
                                                        : ""}
                                                      {index <
                                                        policy
                                                          .policyPrimaryBenificariesNew
                                                          .length -
                                                          1 && ", "}
                                                    </span>
                                                  )
                                                )} */}
                                                  {policy.policyPrimaryBenificariesNew.map(
                                                    (insuredId, index) => {
                                                      const customerName =
                                                        relativeMap.get(
                                                          Number(
                                                            insuredId.column1
                                                          )
                                                        ) || "";

                                                      return (
                                                        <span key={index}>
                                                          {customerName}
                                                          {insuredId.payoutPercentage
                                                            ? `- ${insuredId.payoutPercentage}%`
                                                            : ""}
                                                          {/* {insuredId.column2
                                                              ? ` (${insuredId.column2})`
                                                              : ""} */}
                                                          {index <
                                                            policy
                                                              .policyPrimaryBenificariesNew
                                                              .length -
                                                              1 && ", "}
                                                        </span>
                                                      );
                                                    }
                                                  )}
                                                </Typography>
                                              )}
                                            {firstPolicy.policyRemark && (
                                              <Typography
                                                className={classes.bodyPrint1}
                                              >
                                                <span
                                                  style={{
                                                    fontWeight: fontwhighte,
                                                  }}
                                                >
                                                  Remarks:
                                                </span>{" "}
                                                <Typography
                                                  className={classes.bodyPrint1}
                                                  sx={{
                                                    lineHeight: 0.4,
                                                  }}
                                                  dangerouslySetInnerHTML={{
                                                    __html: policy.policyRemark,
                                                  }}
                                                />
                                                {/* {policy.policyRemark || ""} */}
                                              </Typography>
                                            )}
                                          </TableCell>
                                          <TableCell
                                            className={classes.tablCellReport}
                                            sx={{
                                              textAlign: "right",
                                              width: "20%",
                                              verticalAlign: "top",
                                            }}
                                          >
                                            {policy.policyCoverageAmount && (
                                              <Typography
                                                className={
                                                  classes.bodyPrintHeading
                                                }
                                                sx={{
                                                  textTransform: "uppercase",
                                                  color: "black",
                                                }}
                                              >
                                                {formatNumber(
                                                  policy.policyCoverageAmount ||
                                                    "0.00"
                                                )}
                                              </Typography>
                                            )}
                                          </TableCell>
                                          <TableCell
                                            className={classes.tablCellReport}
                                            sx={{
                                              textAlign: "right",
                                              width: "20%",
                                              verticalAlign: "top",
                                            }}
                                          >
                                            {policy.policyPremiumDetails && (
                                              <Typography
                                                className={
                                                  classes.bodyPrintHeading
                                                }
                                                sx={{
                                                  textTransform: "uppercase",
                                                  color: "black",
                                                }}
                                              >
                                                {formatNumber(
                                                  policy.policyPremiumDetails ||
                                                    "0.00"
                                                )}
                                              </Typography>
                                            )}
                                          </TableCell>
                                        </TableRow>
                                      ))
                                    )}
                                    <TableRow>
                                      <TableCell
                                        className={classes.tablCellReport}
                                        sx={{
                                          width: "50%",
                                        }}
                                      >
                                        <Typography
                                          className={classes.bodyPrint1}
                                        >
                                          <strong>Total Premium</strong>{" "}
                                        </Typography>
                                      </TableCell>
                                      <TableCell
                                        className={classes.tablCellReport}
                                        sx={{
                                          textAlign: "right",
                                          width: "30%",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        <Typography
                                          className={classes.bodyPrintHeading}
                                          sx={{
                                            textTransform: "uppercase",
                                            color: "black",
                                          }}
                                        >
                                          {" "}
                                        </Typography>
                                      </TableCell>
                                      <TableCell
                                        className={classes.tablCellReport}
                                        sx={{
                                          textAlign: "right",
                                          width: "20%",
                                          verticalAlign: "top",
                                        }}
                                      >
                                        <Typography
                                          className={classes.bodyPrintHeading}
                                          sx={{
                                            textTransform: "uppercase",
                                            color: "black",
                                          }}
                                        >
                                          <strong>
                                            {formatNumber(
                                              firstPolicy.policyPremium ||
                                                "0.00"
                                            )}
                                          </strong>
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          // sx={{
                          //   "@media print": {
                          //     pageBreakBefore: "always", // Forces this container to start on a new page
                          //     breakBefore: "always", // Modern equivalent for the same functionality
                          //   },
                          // }}
                        >
                          {initialData && initialData.body_message_start && (
                            <Typography
                              className={classes.bodyPrint1}
                              component="div"
                              sx={{
                                lineHeight: 0.4,
                              }}
                              dangerouslySetInnerHTML={{
                                __html: initialData.body_message_start,
                              }}
                            />
                          )}

                          <List
                            sx={{
                              listStyleType: "disc",
                              m: 0,
                              p: 0,
                              pl: 4,
                              "& .MuiListItem-root": {
                                py: 0,
                                my: 0,
                                mb: 0,
                                m: 0,

                                lineHeight: 0.1,
                                "@media print": {
                                  lineHeight: 0.1,
                                  my: 0,
                                  mb: 0,
                                  m: 0,
                                  py: 0,
                                },
                              },
                            }}
                          >
                            {allPolicyItems.map((item: any, idx: number) => (
                              <ListItem
                                key={idx}
                                sx={{
                                  display: "list-item",
                                  "@media print": {
                                    pageBreakInside: "avoid",
                                  },
                                  lineHeight: 0.1,
                                  paddingTop: 0,
                                  paddingBottom: 0,
                                  m: 0,
                                  p: 0,
                                }}
                              >
                                <ListItemText
                                  primary={
                                    <Typography
                                      className={classes.bodyPrint133}
                                      component="div"
                                      sx={{ lineHeight: 1.1 }}
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          item.policyTermsDescription ||
                                          item.policyTermsDescription,
                                      }}
                                    />
                                  }
                                />
                              </ListItem>
                            ))}
                          </List>

                          {initialData && initialData.body_message_end && (
                            <Typography
                              className={classes.bodyPrint133}
                              component="div"
                              sx={{
                                lineHeight: 0.4,
                              }}
                              dangerouslySetInnerHTML={{
                                __html: initialData.body_message_end,
                              }}
                            />
                          )}

                          {initialData && initialData.footer_message && (
                            <Grid sx={{ mt: 3 }}>
                              <Typography
                                className={classes.bodyPrint133}
                                component="div"
                                sx={{
                                  lineHeight: 0.2,
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: initialData.footer_message,
                                }}
                              />
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </PrintContainer>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.quotesCardInvoice}>
            <Grid container spacing={1} padding={"2px"}>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                  <Grid item>
                    <ReactToPrint
                      trigger={() => (
                        <Button
                          variant="contained"
                          startIcon={<LocalPrintshopSharpIcon />}
                          className={classes.addButton}
                        >
                          Print
                        </Button>
                      )}
                      documentTitle={documentName}
                      content={() => componentRef.current}
                      pageStyle={`
                        @page {
                          margin: 5mm 1mm 10mm 1mm;

                          @top-right-corner {
                              content: "  ";
                            }
                          @bottom-right {
                            content: "Page " counter(page);
                          }
                        }
                        @media print {
                          body {
                            margin: 0;
                            padding: 0;
                          }
                    
                          table {
                            margin: 0 !important;
                            padding: 0 !important;
                            border-collapse: collapse !important;
                          }
                    
                          th, td {
                            padding: 4px !important; /* Optional: you can control cell spacing here */
                          }

                          /* 🔹 Compact list styling */
                          ul, ol {
                            margin: 0 !important;
                            padding-left: 16px !important;
                          }

                          li {
                            margin-bottom: 1px !important;  /* 👈 reduce space between list items */
                            line-height: 0.95 !important;   /* 👈 tighter line spacing */
                            padding: 0 !important;
                          }
                        }
                      `}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default Index;
